var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h4", [_vm._v(_vm._s(_vm.titulo))]),
    _c("h5", { staticStyle: { color: "#aaaaaa" } }, [
      _vm._v(_vm._s(_vm.subtitulo))
    ]),
    _c(
      "form",
      {
        staticStyle: { width: "100%", "margin-top": "30px" },
        attrs: { "data-vv-scope": "formularioCeder" }
      },
      [
        _c("h5", [_vm._v("Datos del Cesionario")]),
        _c("div", { staticClass: "vx-row mt-3" }, [
          _c(
            "div",
            { staticClass: "vx-col md:w-1/2 w-full" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|validaRut",
                    expression: "'required|validaRut'"
                  }
                ],
                staticClass: "w-full",
                attrs: {
                  label: "RUT (sin puntos, con guión)",
                  maxlength: "10",
                  name: "cesionarioRut"
                },
                model: {
                  value: _vm.ceder.cesionarioRut,
                  callback: function($$v) {
                    _vm.$set(_vm.ceder, "cesionarioRut", $$v)
                  },
                  expression: "ceder.cesionarioRut"
                }
              }),
              _vm.getError("cesionarioRut") == "required"
                ? _c(
                    "span",
                    { staticClass: "text-danger text-sm form-error-message" },
                    [_vm._v("RUT es obligatorio")]
                  )
                : _vm._e(),
              _vm.getError("cesionarioRut") == "rut"
                ? _c(
                    "span",
                    { staticClass: "text-danger text-sm form-error-message" },
                    [_vm._v("Formato de RUT incorrecto")]
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "vx-col w-full mt-2" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "w-full",
                attrs: {
                  label: "Razón Social",
                  maxlength: "60",
                  name: "cesionarioRazonSocial"
                },
                model: {
                  value: _vm.ceder.cesionarioRazonSocial,
                  callback: function($$v) {
                    _vm.$set(_vm.ceder, "cesionarioRazonSocial", $$v)
                  },
                  expression: "ceder.cesionarioRazonSocial"
                }
              }),
              _vm.getError("cesionarioRazonSocial") == "required"
                ? _c(
                    "span",
                    { staticClass: "text-danger text-sm form-error-message" },
                    [_vm._v("Razón social es oblitagorio")]
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "vx-col w-full mt-2" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "w-full",
                attrs: {
                  label: "Dirección",
                  maxlength: "80",
                  name: "cesionarioDireccion"
                },
                model: {
                  value: _vm.ceder.cesionarioDireccion,
                  callback: function($$v) {
                    _vm.$set(_vm.ceder, "cesionarioDireccion", $$v)
                  },
                  expression: "ceder.cesionarioDireccion"
                }
              }),
              _vm.getError("cesionarioDireccion") == "required"
                ? _c(
                    "span",
                    { staticClass: "text-danger text-sm form-error-message" },
                    [_vm._v("Dirección es obligatoria")]
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "vx-col w-full mt-2" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|email",
                    expression: "'required|email'"
                  }
                ],
                staticClass: "w-full",
                attrs: {
                  type: "email",
                  label: "Email",
                  maxlength: "90",
                  name: "cesionarioMail"
                },
                model: {
                  value: _vm.ceder.cesionarioMail,
                  callback: function($$v) {
                    _vm.$set(_vm.ceder, "cesionarioMail", $$v)
                  },
                  expression: "ceder.cesionarioMail"
                }
              }),
              _vm.getError("cesionarioMail") == "required"
                ? _c(
                    "span",
                    { staticClass: "text-danger text-sm form-error-message" },
                    [_vm._v("Correo electrónico es obligatorio")]
                  )
                : _vm._e(),
              _vm.getError("cesionarioMail") == "email"
                ? _c(
                    "span",
                    { staticClass: "text-danger text-sm form-error-message" },
                    [_vm._v("Correo electrónico es incorrecto")]
                  )
                : _vm._e()
            ],
            1
          )
        ]),
        _c("h5", { staticClass: "mt-4" }, [_vm._v("Datos de contacto")]),
        _c("div", { staticClass: "vx-row mt-3" }, [
          _c(
            "div",
            { staticClass: "vx-col w-full" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|alpha_spaces",
                    expression: "'required|alpha_spaces'"
                  }
                ],
                staticClass: "w-full",
                attrs: {
                  label: "Nombre",
                  maxlength: "60",
                  name: "contactoNombreContacto"
                },
                model: {
                  value: _vm.ceder.contactoNombreContacto,
                  callback: function($$v) {
                    _vm.$set(_vm.ceder, "contactoNombreContacto", $$v)
                  },
                  expression: "ceder.contactoNombreContacto"
                }
              }),
              _vm.getError("contactoNombreContacto") == "required"
                ? _c(
                    "span",
                    { staticClass: "text-danger text-sm form-error-message" },
                    [_vm._v("Nombre del contacto es necesario")]
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "vx-col md:w-1/2 w-full mt-2" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|email",
                    expression: "'required|email'"
                  }
                ],
                staticClass: "w-full",
                attrs: {
                  type: "email",
                  label: "Email",
                  maxlength: "90",
                  name: "contactoEmailContato"
                },
                model: {
                  value: _vm.ceder.contactoEmailContato,
                  callback: function($$v) {
                    _vm.$set(_vm.ceder, "contactoEmailContato", $$v)
                  },
                  expression: "ceder.contactoEmailContato"
                }
              }),
              _vm.getError("contactoEmailContato") == "required"
                ? _c(
                    "span",
                    { staticClass: "text-danger text-sm form-error-message" },
                    [_vm._v("Correo electrónico es obligatorio")]
                  )
                : _vm._e(),
              _vm.getError("contactoEmailContato") == "email"
                ? _c(
                    "span",
                    { staticClass: "text-danger text-sm form-error-message" },
                    [_vm._v("Correo electrónico es incorrecto")]
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "vx-col md:w-1/2 w-full" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|numeric",
                    expression: "'required|numeric'"
                  }
                ],
                staticClass: "w-full",
                attrs: {
                  label: "Teléfono",
                  maxlength: "12",
                  placeholder: "569",
                  name: "contactoTelefonoContacto"
                },
                model: {
                  value: _vm.ceder.contactoTelefonoContacto,
                  callback: function($$v) {
                    _vm.$set(_vm.ceder, "contactoTelefonoContacto", $$v)
                  },
                  expression: "ceder.contactoTelefonoContacto"
                }
              }),
              _vm.getError("contactoTelefonoContacto") == "required"
                ? _c(
                    "span",
                    { staticClass: "text-danger text-sm form-error-message" },
                    [_vm._v("Número de contacto es requerido")]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]
    ),
    _c("div", { attrs: { align: "right" } }, [
      _c(
        "div",
        [
          _c(
            "vs-button",
            {
              attrs: { color: "primary", type: "filled" },
              on: { click: _vm.enviarCeder }
            },
            [_vm._v("Ceder")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }